import {
  DataTable,
  DataTableProps,
} from "../../../components/common/data-table/DataTable";
import Loading from "../../../components/Loading";
import { ColumnInterface } from "../../../interfaces/customTableInterface";
import { ShippingCost } from "../../../interfaces/shippingCostType";

type ShippingCostTableProps = {
  data: ShippingCost[];
  isLoading: boolean;
} & Pick<
  DataTableProps<ShippingCost>,
  "pagination" | "extraActions" | "sortBy" | "sortOrder" | "onSort"
>;

const columns: ColumnInterface<ShippingCost>[] = [
  { key: "name", label: "Nombre" },
  { key: "price", label: "Precio de envío" },
  { key: "cost", label: "Costo de envío" },
  { key: "order", label: "Orden" },
  { key: "defaultShipping", label: "Default", isBoolean: true },
  { key: "active", label: "Activo", isBoolean: true },
];

export const ShippingCostTable = (props: ShippingCostTableProps) => {
  const { isLoading, ...rest } = props;

  if (isLoading) return <Loading />;

  return (
    <DataTable
      columns={columns}
      tableId="shipping-cost-table"
      customRender={(key, item) => {
        if (key === "active") {
          return item.active ? "Activo" : "Inactivo";
        }
        return item[key] ?? "N/A";
      }}
      {...rest}
    />
  );
};
